import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootRedirectGuard } from '@core/guard/root-redirect.guard';
import { ChatbotEnabledGuard } from '@core/guard/chatbot-enabled.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/admin/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/admin/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'profiler',
    loadChildren: () => import('./pages/profiler/profiler.module').then((m) => m.ProfilerModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/admin/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'myaccount',
    loadChildren: () => import('./pages/admin/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'myaccount#id_token=:jwt',
    loadChildren: () => import('./pages/admin/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'businessplans',
    loadChildren: () => import('./pages/admin/business-plans/business-plans.module').then((m) => m.BusinessPlansModule),
  },
  {
    path: 'myapps',
    loadChildren: () => import('./pages/admin/app-container/app-container.module').then((m) => m.AppContainerModule),
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/admin/team/team.module').then((m) => m.TeamModule),
  },
  {
    path: 'permissions',
    loadChildren: () => import('./pages/admin/permissions/permissions.module').then((m) => m.PermissionsModule),
  },
  {
    path: 'billing',
    loadChildren: () => import('./pages/admin/billing/billing.module').then((m) => m.BillingModule),
  },
  {
    path: 'billing/:id',
    loadChildren: () =>
      import('./pages/admin/billing/billing-detail/billing-detail.module').then((m) => m.BillingDetailModule),
  },
  {
    path: 'company',
    loadChildren: () => import('./pages/admin/company/company.module').then((m) => m.CompanyModule),
  },
  {
    path: 'analyze',
    loadChildren: () => import('./pages/analyze/analyze.module').then((m) => m.AnalyzeModule),
  },
  {
    path: 'batch',
    loadChildren: () =>
      import('./pages/admin/app-container/app-container-routing.module').then((m) => m.AppContainerRoutingModule),
  },
  {
    path: 'certify',
    loadChildren: () =>
      import('./pages/admin/app-container/app-container-routing.module').then((m) => m.AppContainerRoutingModule),
  },
  {
    path: 'certify2',
    loadChildren: () => import('./pages/certify/certify.module').then((m) => m.CertifyModule),
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: 'record',
    loadChildren: () => import('./pages/record/record.module').then((m) => m.RecordModule),
  },
  {
    path: 'plan',
    loadChildren: () => import('./pages/plan/plan.module').then((m) => m.PlanModule),
  },
  {
    path: 'adminmanager',
    loadChildren: () => import('./pages/admin-manager/admin-manager.module').then((m) => m.AdminManagerModule),
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/admin/logout/logout.module').then((m) => m.LogoutModule),
  },
  {
    path: 'logout-offline',
    loadChildren: () => import('./pages/admin/logout-offline/logout-offline.module').then((m) => m.LogoutOfflineModule),
  },
  {
    path: 'recoverpassword',
    loadChildren: () =>
      import('./pages/admin/recover-password/recover-password.module').then((m) => m.RecoverPasswordModule),
  },
  {
    path: 'resetpassword',
    loadChildren: () => import('./pages/admin/reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./pages/admin/checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'redirect',
    loadChildren: () => import('./pages/redirect/redirect.module').then((m) => m.RedirectModule),
  },
  {
    path: 'dispatch',
    loadChildren: () => import('./pages/dispatch/dispatch.module').then((m) => m.DispatchModule),
  },
  {
    path: 'make',
    loadChildren: () => import('./pages/make/make.module').then((m) => m.MakeModule),
  },
  {
    path: 'stock',
    loadChildren: () => import('./pages/stock/stock.module').then((m) => m.StockModule),
  },
  {
    path: 'callOut',
    loadChildren: () =>
      import('./pages/call-out-notification/call-out-notification.module').then((m) => m.CallOutNotificationModule),
  },
  {
    path: 'orderPublicUnblock/:action/:id/:from/:tennatCode/:userGuid/:lng',
    loadChildren: () =>
      import('../app/pages/order-public-unblock/order-public-unblock.module').then((m) => m.OrderPublicUnblock),
  },
  {
    path: 'optimize',
    loadChildren: () => import('./pages/plan/plan.module').then((m) => m.PlanModule),
  },
  {
    path: 'invoice',
    loadChildren: () => import('./pages/invoice/invoice.module').then((m) => m.InvoiceModule),
  },
  {
    path: 'dispatch-console',
    loadChildren: () => import('./pages/dispatch-console/dispatch-console.module').then((m) => m.DispatchConsoleModule),
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'role-permissions',
    loadChildren: () =>
      import('./pages/admin/permissions/role-permission/role-permission.module').then((m) => m.RolePermissionModule),
  },
  {
    path: 'team',
    loadChildren: () => import('./pages/admin/team/team-layout/team-layout.module').then((m) => m.TeamLayoutModule),
  },
  {
    path: 'pumping',
    loadChildren: () => import('./pages/pumping/pumping.module').then((m) => m.PumpingModule),
  },
  {
    path: 'invite',
    loadChildren: () => import('./pages/admin/invite/invite.module').then((m) => m.InviteModule),
  },
  {
    path: 'drive',
    loadChildren: () => import('./pages/drive/drive.module').then((m) => m.DriveModule),
  },
  {
    path: 'talk-to-your-data',
    canActivate: [ChatbotEnabledGuard],
    loadChildren: () => import('@certify').then((m) => m.TalkToYourDataModule),
  },
  // Keep landing last so it doesn't capture other top-level routes
  {
    path: '',
    canActivate: [RootRedirectGuard],
    loadChildren: () => import('./pages/landing/landing.module').then((m) => m.LandingModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
